(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page--cart--footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page--product--recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            //console.log(text)
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              var splide = new Splide( '.page--product--recommendations__splide', {
                perPage: 3,
                pagination: false,
                arrows: true,
                gap: '1.5rem',
                autoWidth: false,
                resetProgress: false,
                breakpoints: {
                  478: {
                    perPage: 1,
                    arrows: false,
                    padding: { left: '1.75rem', right: '5rem' },
                    gap: '1.25rem'
                  }
                }
              } );
              
              splide.mount();
            }
          })
          .catch(e => {
            console.error(e);
          });

          
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 800px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
